import React from 'react';
import { FormRow, FormRowSelect, FormRowStep, Alert } from '../../components';
import { useAppContext } from '../../context/appContext';
import { Navigate } from 'react-router-dom';

import Wrapper from '../../assets/wrappers/DashboardFormPage';

const AddProduct = () => {
  const {
    isLoading,
    isEditing,
    showAlert,
    displayAlert,
    handleChange,
    clearValues,
    productName,
    productType,
    productTypeOptions,
    category,
    categoryOptions,
    supplierOptions,
    vending,
    caseCost,
    caseQty,
    supplier,
    createProduct,
    editProduct,
    updatedMachineRows,
    user,
  } = useAppContext();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !productName ||
      !productType ||
      !vending ||
      !caseCost ||
      !caseQty ||
      !supplier
    ) {
      displayAlert();
      return;
    }

    if (isEditing) {
      editProduct();
      return;
    }

    createProduct();
  };

  const handleProductInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({ name, value });
  };

  if (
    user.role === 'stocker' ||
    user.role === 'driver' ||
    user.role === 'stocker-driver'
  ) {
    return <Navigate to='/' />;
  }

  return (
    <Wrapper>
      <form className='form'>
        <h3>{isEditing ? 'Edit Product' : 'Add Product'}</h3>

        {showAlert && <Alert />}

        <div className='form-center'>
          {/* Product Name */}
          <FormRow
            labelText='Product Name'
            type='text'
            name='productName'
            value={productName}
            handleChange={handleProductInput}
          />

          {/* Product Type */}
          <FormRowSelect
            name='productType'
            value={productType}
            labelText='Product Type'
            handleChange={handleProductInput}
            list={productTypeOptions}
          />

          {/* Category */}
          <FormRowSelect
            name='category'
            value={category}
            labelText='Category'
            handleChange={handleProductInput}
            list={categoryOptions}
          />

          {/* Price */}
          <FormRowStep
            labelText='Price'
            type='number'
            name='vending'
            value={vending}
            step='0.05'
            handleChange={handleProductInput}
          />

          {/* Case Cost */}
          <FormRowStep
            labelText='Case Cost'
            type='number'
            name='caseCost'
            value={caseCost}
            step='0.01'
            handleChange={handleProductInput}
          />

          {/* Case Quantity */}
          <FormRowStep
            labelText='Case Quantity'
            type='number'
            name='caseQty'
            value={caseQty}
            step='1'
            handleChange={handleProductInput}
          />

          {/* Supplier */}
          <FormRowSelect
            name='supplier'
            value={supplier}
            handleChange={handleProductInput}
            list={supplierOptions}
          />

          {/* Buttons */}
          <div className='btn-container'>
            <button
              type='submit'
              className='btn btn-block submit-btn'
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Submit'}
            </button>

            <button
              className='btn btn-block clear-btn'
              onClick={(e) => {
                e.preventDefault();
                clearValues();
              }}
            >
              Clear
            </button>
          </div>
        </div>

        {/* Updated Machine Rows */}
        {updatedMachineRows?.length > 0 && (
          <div className='updated-rows'>
            <h4>Updated Machine Locations ({updatedMachineRows.length})</h4>

            <div className='updated-rows-list'>
              {updatedMachineRows.map((row, index) => (
                <div
                  className='updated-row-card'
                  key={`${row.machineId}-${row.location}-${index}`}
                >
                  <div>
                    <strong>{row.machineName}</strong>
                  </div>

                  <div>
                    <strong>Location:</strong> {row.location}
                  </div>

                  <div>
                    <strong>Product:</strong> {row.oldProductName} →{' '}
                    {row.newProductName}
                  </div>

                  <div>
                    <strong>Price:</strong> ${Number(row.oldPrice).toFixed(2)} →
                    ${Number(row.newPrice).toFixed(2)}
                  </div>

                  <div>
                    <strong>Matched By:</strong> {row.matchedBy}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </form>
    </Wrapper>
  );
};

export default AddProduct;
